import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getPatientDiagnosis(patientId) {
        return Axios.get(`${baseURL}record/diagnosis/${patientId}`).then(
            response => response.data.response
        );
    },
    getDiagnosisDetails(patientId, diagnosisId) {
        return Axios.get(
            `${baseURL}record/diagnosis/${patientId}/${diagnosisId}`
        ).then(response => response.data.response);
    },
    editRecordDetails(recordId) {
        return Axios.get(`${baseURLci}patient/record/edit`, {
            params: { id: recordId }
        }).then(response => response.data);
    },
    showRecordDetails(recordId, businessId) {
        return Axios.get(`${baseURLci}patient/record/show`, {
            params: { id: recordId, business_id: businessId }
        }).then(response => response.data);
    },
    duplicateRecordDetails(recordId) {
        return Axios.get(
            `${baseURLci}patient/record/duplicate_medical_record`,
            {
                params: { id: recordId }
            }
        ).then(response => response.data);
    },
    refillRecordDetails(recordId) {
        return Axios.get(`${baseURLci}patient/refill/add`, {
            params: { id: recordId }
        }).then(response => response.data);
    },
    getCreateDetails(patientId) {
        return Axios.get(`${baseURLci}patient/record/create`, {
            params: { id: patientId }
        }).then(response => response.data);
    },
    getNoteSummary(patientId, soapId) {
        return Axios.get(
            `${baseURL}record/medical-note/${patientId}/${soapId}`
        ).then(response => response.data.response);
    },
    getRecordRefillRequest(requestId) {
        return Axios.get(`${baseURL}record/refill-request/${requestId}`).then(
            response => response.data.response
        );
    },
    updateRecordRefillRequest(requestId, data) {
        return Axios.put(
            `${baseURL}record/refill-request/${requestId}`,
            data
        ).then(response => response.data.response);
    },
    getRecordRefillRequests(patientId, param) {
        return Axios.get(
            `${baseURL}record/refill-request-by-patient/${patientId}`,
            { params: param }
        ).then(response => response.data.response);
    },
    getPatientRecordRefillRequests(param) {
        return Axios.get(`${baseURL}record/refill-request`, {
            params: param
        }).then(response => response.data.response);
    },
    getRecordRefillRequestsCountByPatientId(patientId) {
        return Axios.get(
            `${baseURL}record/refill-request-status/${patientId}`
        ).then(response => response.data.response);
    },
    getRecordRefillRequestsCount() {
        return Axios.get(`${baseURL}record/refill-request-status`).then(
            response => response.data.response
        );
    },
    getRxRequests(param) {
        return Axios.get(`${baseURL}record/rx-request`, {
            params: param
        }).then(response => response.data.response);
    },
    getRxRequestsStatus(param) {
        return Axios.get(`${baseURL}record/rx-request-status`, {
            params: param
        }).then(response => response.data.response);
    },
    fetchAsterisResult(recordId) {
        return Axios.get(`${baseURL}lab/fetch-asteris-result/${recordId}`).then(
            response => response.data.response
        );
    },
    submitRecommendation(params) {
        return Axios.post(`${baseURL}record/recommendation`, {
            params
        }).then(response => response.data.response);
    },
    syncRecords(params) {
        return Axios.post(`${baseURL}record/recommendation/sync-client-patient`, {
            ...params
        }).then(response => response.data.response);
    },
    getSyncStatus() {
        return Axios.get(
            `${baseURL}record/sync/VETSOURCE/progress-status`
        ).then(response => response.data.response);
    },
    denyRxRequest(recordId, params) {
        return Axios.post(`${baseURL}record/rx-request-deny/${recordId}`, {
            ...params
        }).then(response => response.data.response);
    },
    approveRxRequest(recordId, params) {
        return Axios.post(`${baseURL}record/rx-request-approve/${recordId}`, {
            ...params
        }).then(response => response.data.response);
    }
};
